
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Page from '../components/Page';
import { Box, Typography, CircularProgress } from '@mui/material';
export default function EscalatedVideo() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  let videoUrl = queryParams.get('video') || '';

  const ErrorMessage = styled(Typography)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'top',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '2rem !important',
    textAlign: 'center',
    marginTop:theme.spacing(2),
  }));

  return (
    <Page title="Video Stream Player">
      {videoUrl ? 
      (
        <iframe
          src={videoUrl}
          allowFullScreen
          style={{
            width: '100vw',
            height: '100vh',
            border: 'none',
            display: 'block',
          }}
        />
      ) : (
        <ErrorMessage>Invalid Video Link</ErrorMessage>
      )}
    </Page>
  );
}